import * as React from 'react';

const SortDownIcon = ({ color }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 4.06667C9 3.47756 8.55228 3 8 3C7.44772 3 7 3.47756 7 4.06667V9.86807L5.43756 8.25469C5.1087 7.9151 4.57551 7.9151 4.24665 8.25469C3.91778 8.59428 3.91778 9.14485 4.24665 9.48444L7.40454 12.7453C7.7334 13.0849 8.2666 13.0849 8.59546 12.7453L11.7534 9.48444C12.0822 9.14485 12.0822 8.59428 11.7534 8.25469C11.4245 7.9151 10.8913 7.9151 10.5624 8.25469L9 9.86807V4.06667Z"
      fill={color}
    />
  </svg>
);
export default SortDownIcon;
